import { render } from "./MyResult.vue?vue&type=template&id=10a5b71b&scoped=true"
import script from "./MyResult.vue?vue&type=script&lang=js"
export * from "./MyResult.vue?vue&type=script&lang=js"

import "./MyResult.vue?vue&type=style&index=0&id=10a5b71b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a5b71b"]])

export default __exports__